import { Box, Flex, HStack, Image } from "@chakra-ui/react";
import AppIcons from "assets/icon/Appicons";
import AppTypography from "components/common/typography/AppTypography";
import useLocaleResources from "hooks/useLocaleResources/useLocaleResources";
import arLocale from "locales/public-pages/blogs/ar.json";
import enLocale from "locales/public-pages/blogs/en.json";
import React from "react";
import { getTimeAgo } from "utils/helpers";
import { IBlogDetail } from "./blogs.interface";


const LatestBlog = ({ blog }: { blog: IBlogDetail }) => {
    const { t } = useLocaleResources("blogs", {
        ar: arLocale,
        en: enLocale,
    });

    return (
        <Box width={"full"} pos={"relative"} height={"512px"}>
            <Image width={"full"} height={"512px"} objectFit={"cover"} rounded={"32px"} src={blog?.image} />
            <Flex
                position={"absolute"}
                rounded={"32px"}
                gap={"24px"}
                direction={"column"}
                height={"50%"}
                bg={"#00000080"}
                bottom={"0px"}
                left={"0px"}
                width={"full"}
                alignItems={"start"}
                justifyContent={"center"}
                padding={"24px"}
            >
                <AppTypography color="white" fontSize={"32px"} fontWeight={"700"} width={"full"}>
                    {blog?.title}
                </AppTypography>
                <HStack>
                    <AppIcons.Clock fill="#C2C2C2" width={"16px"} height={"16px"} />
                    <AppTypography color="white" fontWeight={"500"} fontSize={"18px"}>
                        {t("latestBlog.lastUpdate", { time: getTimeAgo(blog?.createdAt) })}
                    </AppTypography>
                </HStack>
                <HStack>
                    <AppIcons.Pen width={"16px"} height={"16px"} color="#C2C2C2" />
                    <AppTypography color="white" fontWeight={"500"} fontSize={"18px"}>
                        {t("latestBlog.by", { writer: blog?.writer })}
                    </AppTypography>
                </HStack>
                <HStack spacing={"12px"} align={"stretch"}>
                    {blog?.tags?.map((tag) => (
                        <Box key={tag} paddingX={"8px"} paddingY={"4px"} bg={"#2EC99E"} rounded={"16px"}>
                            <AppTypography color="#084836" fontSize={"14px"} fontWeight={"500"}>
                                {tag}
                            </AppTypography>
                        </Box>
                    ))}
                </HStack>
            </Flex>
        </Box>
    );
};

export default LatestBlog;
